<template>
  <div
    class="site-trust hp-block-container"
    :class="{ 'site-trust--cards': variant === 'cards' }"
  >
    <h3 class="hp-block-title">Safe, secure and regulated</h3>
    <p class="site-trust-intro">
      Pedalsure has been insuring cyclists since 2014. Here's how we keep you,
      your details and your money safe.
    </p>
    <div class="site-trust-grid">
      <div class="site-trust-item">
        <img
          src="~/assets/images/icons/blue/approved-lock.svg"
          class="icon"
          alt=""
        />
        <div class="subtitle">A verified, encrypted website</div>
        <p>
          Every page of pedalsure.com is protected by an Extended Validation SSL
          certificate from Sectigo. What you send us stays private, and Sectigo
          has independently checked that you're dealing with the real Pedalsure.
        </p>
        <SecuritySeal class="site-trust-seal" />
      </div>
      <div class="site-trust-item">
        <img
          src="~/assets/images/icons/blue/payment-promise.svg"
          class="icon"
          alt=""
        />
        <div class="subtitle">Safe, secure payments</div>
        <p>
          Every payment is made over an encrypted connection, through secure
          payment providers. We never store your full card details.
        </p>
      </div>
      <div class="site-trust-item">
        <img src="~/assets/images/icons/blue/policy.svg" class="icon" alt="" />
        <div class="subtitle">How we're regulated</div>
        <p>
          <RegulatoryStatement variant="inline" />
          <nuxt-link no-prefetch to="/what-we-cover">Who we are</nuxt-link>
        </p>
      </div>
      <div class="site-trust-item">
        <img
          src="~/assets/images/icons/blue/terms-and-conditions.svg"
          class="icon"
          alt=""
        />
        <div class="subtitle">Your data, respected</div>
        <p>
          We handle your personal information in line with UK data protection
          law, and you stay in control of how we contact you.
          <nuxt-link no-prefetch to="/contact-permissions">
            Data protection
          </nuxt-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SecuritySeal from '@/components/SecuritySeal'
import RegulatoryStatement from '@/components/common/RegulatoryStatement'

export default {
  name: 'SiteTrust',
  components: { SecuritySeal, RegulatoryStatement },
  props: {
    // 'cards' (contact page): left-aligned, small icons, each item a card.
    variant: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.site-trust-intro {
  max-width: 60ch;
  margin: -10px auto 30px;
  text-align: center;
  font-family: $family-regular;
  color: $ps-body-color;
}

.site-trust-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  @include tablet {
    grid-template-columns: 1fr 1fr;
  }
  @include desktop {
    grid-template-columns: repeat(4, 1fr);
  }
}

.site-trust-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 10px;

  .icon {
    width: 60px;
    height: 60px;
  }
  .subtitle {
    font-size: 1.2rem;
    margin: 15px 0 10px;
  }
  p {
    font-family: $family-regular;
    font-size: 0.95rem;
    line-height: 1.4rem;
  }
}

.site-trust-seal {
  margin-top: 15px;
}

.site-trust--cards {
  padding: 0;

  .hp-block-title,
  .site-trust-intro {
    text-align: left;
    margin-left: 0;
  }
  .hp-block-title {
    font-size: 26px;
    font-weight: 700;
    letter-spacing: -0.02em;
  }
  .site-trust-intro {
    margin-top: 0;
    margin-bottom: 24px;
  }
  .site-trust-grid {
    gap: 12px;
  }
  .site-trust-item {
    align-items: flex-start;
    text-align: left;
    padding: 20px;
    background: $ps-white;
    border: 1px solid $ps-border-color;
    border-radius: $ps-radius-md;

    .icon {
      width: 36px;
      height: 36px;
    }
    .subtitle {
      font-size: 1rem;
      font-weight: 700;
      margin: 14px 0 8px;
    }
    p {
      font-size: 0.875rem;
      line-height: 1.5;
      color: $ps-body-color;
    }
  }
}
</style>
